import { create } from "zustand";

export interface NotificationRecord {
  requestId?: string;
  id?: string | number;
  title?: string;
  message?: string;
  priority?: string;
  category?: string;
  isRead?: boolean;
  timestamp?: string;
  createdAt?: string | number;
  requestEpoch?: string | number;
  publisherName?: string;
  [key: string]: unknown;
}

interface NotificationModalState {
  notification: NotificationRecord | null;
  showModal: boolean;
  openModal: (notification: NotificationRecord) => void;
  closeModal: () => void;
}

const useNotificationModalStore = create<NotificationModalState>((set) => ({
  notification: null,
  showModal: false,
  openModal: (notification) => set({ notification, showModal: true }),
  closeModal: () => set({ showModal: false, notification: null }),
}));

export { useNotificationModalStore };
